<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation-example-2"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="https://authentic.net"><img src="static/img/authentic_net_lt.png" width="200" alt="Authentic.net"></a>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/login" tag="li">
              <a>Login</a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Reset your password</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Password</label>
                        <input
                          type="password"
                          name="password"
                          ref="password"
                          v-model="model.password"
                          v-validate="modelValidations.password"
                          placeholder="Password"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="password.invalid">
                          {{ getError('password') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          name="passwordConfirm"
                          ref="passwordConfirm"
                          v-model="model.passwordConfirm"
                          v-validate="modelValidations.passwordConfirm"
                          placeholder="Confirm Password"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="passwordConfirm.invalid">
                          {{ getError('passwordConfirm') }}
                        </small>
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit" v-if="!loading" @click.prevent="validateThenSubmit()" class="btn btn-fill btn-wd ">Submit</button>
                      <button type="button" v-if="loading" class="btn btn-wd " disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; Copyright 2019 Authentic.net
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Sign Up</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import firebase from 'firebase'

  export default {
    computed: {
      ...mapFields(['password', 'passwordConfirm'])
    },
    data () {
      return {
        loading: false,
        model: {
          password: '',
          passwordConfirm: ''
        },
        modelValidations: {
          password: {
            required: true,
            confirmed: 'passwordConfirm'
          },
          passwordConfirm: {
            required: true
          }
        },
        oobCode: ''
      }
    },
    methods: {
      init () {
        this.oobCode = this.$route.params.oobCode
      },
      validateThenSubmit () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.submit()
          } else {
            this.loading = false
          }
        })
      },
      submit () {
        this.loading = true
        firebase.auth().confirmPasswordReset(this.oobCode, this.model.password)
        .then(response => {
          swal.fire({
            title: `Success!`,
            text: 'Your password was reset. Please proceed to login.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          }).then(() => {
            this.loading = false
            this.$router.replace('/login')
          })
        })
        .catch(error => {
          swal.fire({
            title: 'Error',
            text: error.message + ' Please try to reset your password again or contact support.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(() => {
            this.loading = false
            this.$router.replace('/login')
          })
        })
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeDestroy () {
      this.closeMenu()
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/ResetPassword.vue